<template>
  <div class="common-card-container">
    <el-card :shadow="shadow">
      <div class="card-title">
        <el-divider direction="vertical" style="width:10px" />
        {{ cardTitle }}
        <div class="header-right">
          <slot name="right" />
        </div>
      </div>
      <slot />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CommonCard',
  props: {
    shadow: {
      type: String,
      default: 'never'
    },
    cardTitle: String
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.el-divider{
  background:#40A6DB;
}
.el-divider--vertical{
    display: inline-block;
    width: 6px;
    height: 1.3em;
    margin: 0 4px 3px 8px;
    vertical-align: middle;
    position: relative;
}
.common-card-container{
  .card-title{
    height: 2em;
    line-height: 2em;
    font-size: 14px;
    font-weight: bold;
    margin-left: 12px;
  }
  .header-right{
    float: right;
  }
}
</style>
